export const profileRoute = {
  path: 'profile',
  component: () => import('pages/profile/ProfilePage.vue'),
  children: [
    {
      name: 'showPersonal',
      path: '',
      redirect: 'info',
    },
    {
      name: 'showPersonalInfo',
      path: 'info',
      component: () => import('pages/profile/PersonalInfo.vue') as any,
    },
    {
      name: 'showPersonalContact',
      path: 'contact',
      component: () => import('pages/profile/Contact.vue') as any,
    },
    {
      name: 'showPersonalPhoto',
      path: 'photo',
      component: () => import('pages/profile/PersonalPhoto.vue') as any,
    },
    {
      name: 'showPersonalPassword',
      path: 'password',
      component: () => import('pages/profile/PersonalPassword.vue') as any,
    },
    {
      name: 'showWifiPassword',
      path: 'wifi_password',
      component: () => import('pages/profile/WifiPassword.vue') as any,
    },
    {
      name: 'showPersonalPublicInfo',
      path: 'public_info',
      component: () => import('pages/profile/PublicInfo.vue') as any,
    },
  ],
};
